// extracted by css-extract-rspack-plugin
export default {"wrapper":"PzkouvKNVK4JVdEB","scroll-top-button-fade-in":"jG5xIzrfC9Q0UM7H","icon":"o64lSKuQ8tEUzTOF"};